export default __webpack_public_path__ + "static/media/24t.4b32e558.jpg";